import { render, staticRenderFns } from "./ConfigTabs.vue?vue&type=template&id=20ea1b83"
import script from "./ConfigTabs.vue?vue&type=script&lang=js"
export * from "./ConfigTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports